<template>
  <mdb-container fluid>
    <mdb-row>
      <mdb-col class="h-align ">
        <div class="custom-control custom-checkbox  margin-15">
          <input
            type="checkbox"
            @change="selectAll()"
            :checked="selectAllCheck"
            class="custom-control-input default-color "
            :id="instance - 1"
          />
          <label class="custom-control-label base-color" :for="instance - 1"
            >Select All</label
          >
        </div>
        <div class="custom-control  custom-checkbox ">
          <input
            type="checkbox"
            @change="unselectAll()"
            :checked="unselectAllCheck"
            class="custom-control-input"
            :id="instance - 2"
          />
          <label class="custom-control-label base-color" :for="instance - 2"
            >Unselect All</label
          >
        </div>
      </mdb-col>
    </mdb-row>
    <hr />
    <mdb-row>
      <mdb-col
        v-for="chunkItem in chunkItems"
        :key="chunkItems.indexOf(chunkItem)"
      >
        <div
          class="custom-control custom-checkbox v-align"
          v-for="item in chunkItem"
          :key="item.id"
        >
          <input
            type="checkbox"
            class="input-item custom-control-input"
            :id="instance + item.id"
            :value="item.name"
            v-model="item.check"
            @change="onItemCheck()"
          />
          <label class="custom-control-label" :for="instance + item.id">{{
            item.name
          }}</label>
        </div>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
export default {
  name: "DtMultiSelect",
  props: { items: { default: [] }, size: { default: 8 } },
  computed: {
    targetItems: {
      get: function() {
        let target = [];

        this.items
          .filter(item => {
            return item.check;
          })
          .forEach(item => target.push(item.name));
        return target;
      },
      set: function(newTarget) {
        this.target = newTarget;
      }
    },
    chunkItems() {
      return this.chunk(this.items, this.size);
    },
    selectAllCheck() {
      return !this.items.some(item => {
        return item.check == false;
      });
    },
    unselectAllCheck() {
      return !this.items.some(item => {
        return item.check == true;
      });
    }
  },
  data() {
    return {
      instance: Math.random()
    };
  },

  methods: {
    selectAll() {
      if (!event.target.checked) return;
      this.items.forEach(item => {
        item.check = true;
      });
      this.$emit("onSelectAll", this.targetItems);
    },
    unselectAll() {
      if (!event.target.checked) return;
      this.targetItems = [];
      this.items.forEach(item => {
        item.check = false;
      });
      this.$emit("onUnselectAll", this.targetItems);
    },
    onItemCheck() {
      this.$emit("onItemCheck", this.targetItems);
    },
    chunk(arr, size) {
      return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
        arr.slice(i * size, i * size + size)
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.h-align {
  display: flex;
}
.v-align {
  display: flex;
  align-items: center;
}
.round-btn {
  border-radius: 200px;
  width: auto;
}
.filter-btn {
  margin-top: 5px;
  display: flex;
}
.margin-15 {
  margin-right: 15px;
}
.custom-control {
  font-size: .9rem;
  width: 45%;
  margin-right: 5%;
  float: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;    
}
</style>
